import {
  TerminalCommandModal
} from './terminal-command-modal.component';

import {
  DebugInfoModal
} from './debug-info-modal.component';

import {
  HddUsageModalController
} from './hdd-usage-modal.component';

import {
  DatabaseUsageModalController
} from './database-usage-modal.component';

export class AdminModalService {
  constructor(
    $modal,
  ) {
    this.$modal = $modal;
  }

  terminalCommand(terminalCommandValue, commandText) {
    console.log(terminalCommandValue, commandText);
    this.$modal.open({
        template: require('./terminal-command-modal.component.html'),
        controller: TerminalCommandModal,
        scope: this.$scope,
        resolve: {
          command: () => terminalCommandValue,
          commandText: () => commandText,
        },
      }).result
      .catch((err) => {
        console.error(err);
      });
  }

  debugInfo() {
    this.$modal.open({
        template: require('./debug-info-modal.component.html'),
        controller: DebugInfoModal,
        scope: this.$scope,
      }).result
      .catch((err) => {
        console.error(err);
      });
  }

  hddStatus() {
    this.$modal.open({
        template: require('../admin/hdd-usage-modal.component.html'),
        controller: HddUsageModalController,
      })
      .result
      .then(result => {
        //console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  databaseStatus() {
    this.$modal.open({
        template: require('../admin/database-usage-modal.component.html'),
        controller: DatabaseUsageModalController,
      })
      .result
      .then(result => {
        //console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }


}



// WEBPACK FOOTER //
// ./src/admin/admin-modal.service.js